import { useOptionValueLookup } from '@/hooks';
import { Autocomplete, TextField } from '@mui/material';
import { useState } from 'react';

export function GroupedOptionsField({
  input: { value, onChange },
  label,
  optionName,
}) {
  const options = useOptionValueLookup(optionName);
  const [inputValue, setInputValue] = useState('');

  function handleChange(event, newValue) {
    onChange(newValue);
  }

  function handleInputChange(event, newInputValue) {
    if (event !== null) {
      setInputValue(newInputValue);
    }
  }

  function getOptionLabel(option) {
    // return options?.[option]?.label
    //   ? `${option}: ${options[option].label}`
    //   : option;

    return options?.[option]?.label ?? option;
  }

  return (
    <Autocomplete
      value={value || []}
      inputValue={inputValue}
      onInputChange={handleInputChange}
      fullWidth
      size="small"
      multiple
      onChange={handleChange}
      options={Object.keys(options || {})}
      groupBy={(option) => options?.[option]?.type?.label}
      getOptionLabel={getOptionLabel}
      renderInput={(params) => <TextField label={label} {...params} />}
    />
  );
}
